// import { Method } from 'state-line';
// import BaseApi from './Base';

// 用户模块
export default (server: string) => ({

});
